import './badge.styl'

function Badge(props) {
  const { type, shape, color } = props

  return (
    <div
      className={`badge ${type ? `badge--${type}` : ''} ${shape ? `badge--${shape}` : ''}`}
      style={color ? { backgroundColor: color } : {}}
    >
      <span>{props.children}</span>
    </div>
  )
}

export default Badge
